import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from 'app/services/app/app.service';
import { ErrorModel } from 'app/models/error-model';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private appService: AppService, private router: Router, private snack: MatSnackBar) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        Log.debug('AuthInterceptor', {headers:req.headers});
        
        const token = this.appService.getToken();
        if (this.appService.isTokenExpired(token)) {
            Log.debug('Token expirado, evitando envío al servidor');
            AppService.clearToken();
            this.router.navigate(['/signin']);
            //return throwError(() => new Error('Token expirado'));
        }


        const redirect = req.context.get(Constants.REDIRECT);
        const defaultHeaders = new HttpHeaders(this.getMyHeaders(req));

        let mergedHeaders = req.headers;
        
        defaultHeaders.keys().forEach(key => {
            if (!req.headers.has(key)) {
                mergedHeaders = mergedHeaders.set(key, defaultHeaders.get(key)!);
            }
        });
        
        const cloned = req.clone({ headers: mergedHeaders });
        
        return next.handle(cloned).pipe(
            catchError((error: HttpErrorResponse) => {
                if (this.esErrorModel(error.error)) {
                    let errorModel:ErrorModel = error.error;
                    errorModel?.errors?.forEach(error => this.appService.showDangerToast(this.appService.getTraduccion(error), 3000));
                }else{
                   // if (error.status == 422) {
                        this.appService.showDangerToast(Constants.MSG_DANGER);
                  //  }
                }

                if (error.status == 401 && redirect) {
                    this.router.navigate(['/signin'], { queryParams: { returnUrl: this.router.url } });
                }
                
                return throwError(() => error);

            })
        );
    }

    getMyHeaders(req: HttpRequest<any>): Record<string, string> {

        const headers: Record<string, string> = {
            'X-CSRFToken': '*',
            //Son headers de respuesta del servidor, no de request.
         //   'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
         //   'Access-Control-Allow-Methods': 'GET,POST,PATCH,DELETE,PUT,OPTIONS',
         //   'Access-Control-Allow-Origin': '*',
            'X-Requested-With': 'XMLHttpRequest',
           // 'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json',
        };

        if (!(req.body instanceof FormData)) {
            headers['Content-Type'] = 'application/json; charset=utf-8';
        }

        const token = this.appService.getToken();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        if (this.appService?.tenantId) {
            Log.debug('tenantId:' + this.appService.tenantId);
            headers['X-Tenant-ID'] = String(this.appService.tenantId);
        }

        //let locationId = this.appService.locationId ? this.appService.locationId : this.appService.clientSelected.locationsId;
        let locationId = this.appService.clientSelected?.locationsId;
        if (locationId) {
            headers['X-Location-ID'] = String(locationId);
        }


        return headers;
    }

        /**
     * Type Guard personalizado para verificar si un objeto es un ErrorModel.
     * @param obj El objeto a verificar.
     * @returns true si el objeto coincide con la estructura de ErrorModel.
     */
    private esErrorModel(obj: any): obj is ErrorModel {
        // 1. Verificar que sea un objeto y no sea null
        if (typeof obj !== 'object' || obj === null) {
            return false;
        }

        // 2. Verificar que las propiedades requeridas existan y tengan el tipo correcto
        const tieneMessage = obj.message == null || 'message' in obj && typeof obj.message === 'string';
        const tieneCode = 'code' in obj && typeof obj.code === 'number';
        // 3. Verificar que 'errors' sea un array (no es necesario comprobar el contenido exacto de los strings aquí)
        const tieneErrors = 'errors' in obj && Array.isArray(obj.errors);

        return tieneMessage && tieneCode && tieneErrors;
    }
}
